/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import { useToast } from '../../hooks/toast'
import { useHistory } from 'react-router'
import usuarios from '../../api/usuarios'
import defaultOptions from '../../api/defaultoption'
import * as Yup from 'yup'
import ReCAPTCHA from 'react-google-recaptcha'
import TextField from '../TextField'
import * as S from './styles'
import Loader from '../Loader'
import { FormGroup, FormGroupIcon } from '../Form/styles'

const FormChangePassword = ({ type, setShowModal }) => {
  const { addToast } = useToast()
  const router = useHistory()

  const [values, setValues] = useState({
    password: '',
    newPassword: '',
    newPasswordConfirm: ''
  })

  const [passView, setPassView] = useState(true)
  const [newPassView, setNewPassView] = useState(true)
  const [newPassConfView, setNewPassConfView] = useState(true)
  const [loading, setLoading] = useState(false)
  const [inputErrors, setInputErrors] = useState(false)

  const [captcha, setCaptcha] = useState({
    value: '',
    expired: false
  })

  const [isNewPasswordEmpty, setNewPasswordEmpty] = useState(true)
  const [isNewPasswordValid, setNewPasswordValid] = useState(false)
  const [isOldPasswordValid, setOldPasswordValid] = useState(true)
  const [passwordValidation, setPasswordValidation] = useState({
    uppercase: false,
    lowercase: false,
    specialChar: false,
    number: false,
    length: false,
    matchConfirmation: false
  })

  useEffect(() => {
    const isPasswordValid =
      passwordValidation.uppercase &&
      passwordValidation.lowercase &&
      passwordValidation.specialChar &&
      passwordValidation.number &&
      passwordValidation.length &&
      !isNewPasswordEmpty
    setNewPasswordValid(isPasswordValid)

    if (values.newPassword !== '' || values.newPasswordConfirm !== '') {
      validatePassword(
        values.newPassword,
        'newPassword',
        values.newPasswordConfirm
      )
    }

    if (values.newPassword === '') {
      setNewPasswordEmpty(true)
    }
  }, [values.newPassword, values.newPasswordConfirm])

  const onCaptchaChange = (value) => {
    if (value === null) {
      setCaptcha({
        value: value,
        expired: true
      })
    } else {
      setCaptcha({ value: value, expired: false })
    }
  }

  const validatePassword = (password, fieldName, confirmPassword) => {
    const uppercaseRegex = /[A-Z]/
    const lowercaseRegex = /[a-z]/
    const specialCharRegex = /[(!@#$%^*&)]/
    const numberRegex = /\d/

    if (fieldName === 'newPassword') {
      setPasswordValidation({
        uppercase: uppercaseRegex.test(password),
        lowercase: lowercaseRegex.test(password),
        specialChar: specialCharRegex.test(password),
        number: numberRegex.test(password),
        length: password.length >= 8,
        matchConfirmation: password === confirmPassword
      })
    }

    if (fieldName === 'newPasswordConfirm') {
      setPasswordValidation((prevValidation) => ({
        ...prevValidation,
        matchConfirmation: values.newPassword === confirmPassword
      }))
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target

    setValues((prevValues) => ({
      ...prevValues,
      [name]: value
    }))

    if (name === 'newPassword') {
      setNewPasswordEmpty(value === '')
      validatePassword(value, 'newPassword', values.newPasswordConfirm)
    }
  }

  const formData = {
    password: values.password,
    newPassword: values.newPassword,
    newPasswordConfirm: values.newPasswordConfirm
  }

  const passSchema = Yup.object().shape({
    password: Yup.string()
      .min(6, '"Senha Atual" deve conter o mínimo de 6 caracteres')
      .required('Campo obrigatório*'),
    newPassword: Yup.string()
      .notOneOf([Yup.ref('password')], '')
      .min(8, '"Nova Senha" deve conter o mínimo de 8 caracteres')
      .required('Campo obrigatório*'),
    newPasswordConfirm: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], 'Senhas não coincidem')
      .min(8, '"Confirmar Nova Senha" deve conter o mínimo de 8 caracteres')
      .required('Campo obrigatório*')
  })

  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoading(true)
    if (!isNewPasswordValid || !passwordValidation.matchConfirmation) {
      addToast({
        type: 'error',
        title: 'Preencha os campos corretamente'
      })
      setLoading(false)
    } else {
      try {
        await passSchema.validate(formData, {
          abortEarly: false
        })

        if (captcha.value === '') {
          addToast({
            type: 'error',
            title: 'Por favor, complete a verificação "Não sou um Robô"'
          })
          setLoading(false)
        } else if (captcha.expired === true) {
          addToast({
            type: 'error',
            title:
              'Verificação expirada. Por favor, marque novamente a caixa de seleção'
          })
          setLoading(false)
        } else {
          await usuarios
            .alterarSenha({
              method: 'PUT',
              headers: defaultOptions.headers,
              body: JSON.stringify({
                senhaAtual: formData.password,
                senhaNova: formData.newPassword
              })
            })
            .then((response) => {
              setLoading(false)
              if (response.ok) {
                addToast({
                  type: 'success',
                  title: 'Sua senha foi alterada com sucesso!'
                })
                if (window.location.pathname === '/alterar-senha') {
                  router.push('/')
                } else {
                  setShowModal((prev) => !prev)
                }

                return response.json
              } else {
                setLoading(false)
                setOldPasswordValid(false)
                addToast({
                  type: 'error',
                  title: 'Senha atual diferente da cadastrada'
                })
              }
            })
            .catch((error) => {
              setLoading(false)
              addToast({
                type: 'error',
                title: `${error}`
              })
            })
        }
      } catch (err) {
        if (err) setLoading(false)

        if (err instanceof Yup.ValidationError) {
          const emptyField = Object.values(err.value).every(
            (value) => value !== ''
          )

          if (!emptyField) {
            addToast({
              type: 'error',
              title: 'Todos os campos devem ser preenchidos'
            })

            const errorArray = err.inner.map(({ path, message }) => {
              return {
                name: path,
                message: message
              }
            })

            const objeto = errorArray.reduce((acc, d) => {
              acc[d.name] = d.message

              return acc
            }, {})

            setInputErrors(objeto)
          } else {
            setLoading(false)
            err.inner.map((error) => {
              addToast({
                type: 'error',
                title: `${error.message}`
              })
            })
          }
        }
      }
    }
  }

  return (
    <S.WrapperSmall>
      <S.RegisterCard type={type}>
        <S.Title>Alterar senha</S.Title>
        {loading ? (
          <Loader
            style={{ position: 'fixed', top: '50%', left: '50%' }}
          ></Loader>
        ) : null}
        <p>
          Por favor, preencha os campos abaixo para alterar sua senha de acesso.
        </p>
        <form action="" onSubmit={handleSubmit}>
          <FormGroup className="form-group required">
            <label htmlFor="email">Digite a senha atual</label>
            <FormGroupIcon className="form-group-icon">
              <TextField
                maxlength={80}
                name="password"
                type={passView ? 'password' : 'text'}
                value={values.password}
                placeholder="Digite a senha atual"
                onChange={handleChange}
                error={!isOldPasswordValid}
                autoFocus
              />
              {!isOldPasswordValid ? (
                <span
                  className={!passView ? 'icon icon-eye' : 'icon icon-eye-cut'}
                  style={{ marginRight: 24 }}
                  onClick={() => setPassView(!passView)}
                ></span>
              ) : (
                <span
                  className={!passView ? 'icon icon-eye' : 'icon icon-eye-cut'}
                  onClick={() => setPassView(!passView)}
                ></span>
              )}
            </FormGroupIcon>
          </FormGroup>
          <FormGroup className="form-group required">
            <label htmlFor="email">Digite a nova senha </label>

            <FormGroupIcon className="form-group-icon">
              <TextField
                maxlength={80}
                name="newPassword"
                type={newPassView ? 'password' : 'text'}
                value={values.newPassword}
                placeholder="Digite a nova senha"
                onChange={handleChange}
                success={isNewPasswordValid}
                error={!isNewPasswordValid}
              />
              {!isNewPasswordEmpty || !isNewPasswordValid ? (
                <span
                  className={
                    !newPassView ? 'icon icon-eye' : 'icon icon-eye-cut'
                  }
                  style={{ marginRight: 24 }}
                  onClick={() => setNewPassView(!newPassView)}
                ></span>
              ) : (
                <span
                  className={
                    !newPassView ? 'icon icon-eye' : 'icon icon-eye-cut'
                  }
                  onClick={() => setNewPassView(!newPassView)}
                ></span>
              )}
            </FormGroupIcon>
          </FormGroup>
          <FormGroup className="form-group required">
            <label htmlFor="email">Confirme a nova senha </label>

            <FormGroupIcon className="form-group-icon">
              <TextField
                maxlength={80}
                name="newPasswordConfirm"
                type={newPassConfView ? 'password' : 'text'}
                value={values.newPasswordConfirm}
                placeholder="Confirme a nova senha"
                onChange={handleChange}
                success={passwordValidation.matchConfirmation}
                error={!passwordValidation.matchConfirmation}
              />
              {!isNewPasswordEmpty || !passwordValidation.matchConfirmation ? (
                <span
                  className={
                    !newPassConfView ? 'icon icon-eye' : 'icon icon-eye-cut'
                  }
                  style={{ marginRight: 24 }}
                  onClick={() => setNewPassConfView(!newPassConfView)}
                ></span>
              ) : (
                <span
                  className={
                    !newPassConfView ? 'icon icon-eye' : 'icon icon-eye-cut'
                  }
                  onClick={() => setNewPassConfView(!newPassConfView)}
                ></span>
              )}
            </FormGroupIcon>
          </FormGroup>
          <S.ErrorList>
            <S.Error
              isValid={passwordValidation.length}
              isPasswordEmpty={isNewPasswordEmpty}
            >
              Ter no mínimo 8 caracteres
            </S.Error>
            <S.Error
              isValid={passwordValidation.uppercase}
              isPasswordEmpty={isNewPasswordEmpty}
            >
              Uma letra maiúscula
            </S.Error>
            <S.Error
              isValid={passwordValidation.lowercase}
              isPasswordEmpty={isNewPasswordEmpty}
            >
              Uma letra minúscula
            </S.Error>
            <S.Error
              isValid={passwordValidation.number}
              isPasswordEmpty={isNewPasswordEmpty}
            >
              Um número
            </S.Error>
            <S.Error
              isValid={passwordValidation.specialChar}
              isPasswordEmpty={isNewPasswordEmpty}
            >
              Um caractere especial pré-definido {'(!@#$%^*&)'}
            </S.Error>
            <S.Error
              isValid={passwordValidation.matchConfirmation}
              isPasswordEmpty={isNewPasswordEmpty}
            >
              A nova senha e a confirmação devem ser iguais
            </S.Error>
          </S.ErrorList>
          <S.CaptchaContainer>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_CAPTCHA_SITEKEY}
              onChange={onCaptchaChange}
            ></ReCAPTCHA>
          </S.CaptchaContainer>
          <S.ChangeButton type="submit">Confirmar nova senha</S.ChangeButton>
        </form>
      </S.RegisterCard>
    </S.WrapperSmall>
  )
}

export default FormChangePassword
